import { useMemo } from 'react'

import { CollectionUUID } from '@library/menu-service'

import { useCollection } from 'hooks/menu-collections/useCollection'
import { RecipeUUID } from 'reducers/menu-recipes/recipes'

/**
 * @description RecipeSet is a container type for a base recipe and its options
 */
type RecipeSet = {
  baseRecipeId: RecipeUUID
  recipeIds: Set<RecipeUUID>
}

export const useCollectionRecipeSets = (collectionId: CollectionUUID | null): RecipeSet[] => {
  const collection = useCollection(collectionId)

  return useMemo(() => {
    if (!collection) {
      return []
    }

    return collection.recipes.map((recipe) => ({
      baseRecipeId: recipe.id,
      recipeIds: new Set([recipe.id, ...recipe.options.map((option) => option.id)]),
    }))
  }, [collection])
}
